<template>
  <section>
    <v-data-iterator :items="limits"
                     hide-default-footer
                     disable-pagination
    >
      <template v-slot:default="props">
        <template v-for="(item, idx) in props.items">
          <v-card tile v-bind:key="idx">
            <v-list-item>
              <v-list-item-content>{{ item.name }}</v-list-item-content>
              <v-list-item-content>
                <v-slider v-model="item.count" color="primary" track-color="success" class="mt-7"
                          thumb-label="always"
                          ticks
                          hide-details
                          min="0" max="30">
                  <template v-slot:prepend>
                    <v-icon color="primary" @click="item.count--">mdi-minus</v-icon>
                  </template>

                  <template v-slot:append>
                    <v-icon color="primary" @click="item.count++">mdi-plus</v-icon>
                  </template>
                </v-slider>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </template>
      </template>
    </v-data-iterator>
    <v-card>
      <v-card-actions class="justify-center">
        <v-btn class="box-shadow" color="primary" @click="loadLimits">Discard</v-btn>
        <v-btn class="box-shadow" color="success" @click="updateLimits">Save</v-btn>
      </v-card-actions>
    </v-card>

  </section>
</template>

<script>
export default {
  props: {
    student: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    limits: []
  }),
  mounted() {
    this.loadLimits()
  },
  methods: {
    loadLimits() {
      this.axios.get(`api/students/${this.$route.params.student_id}/session-limits`)
          .then(({data}) => {
            let local = this.$store.getters.getSessionTypes.map(item => item)
            this.limits = local.map(item => {
              let exists = data.data.find(limit => limit.id === item.id)
              if(exists) return ({...item, count: exists.count})
              return ({...item, count: 0})
            })
          })
    },
    updateLimits() {
      this.app_loading = true
      this.axios.put(`api/students/${this.$route.params.student_id}/session-limits`, {limits: this.limits})
          .then(({data}) => { this.limits = data.data})
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {
            this.app_loading = false
          })
    }
  }

}
</script>